import Vue from "vue";
import Vuex from "vuex";
import tab from "./tab";
import business from "./business";
import user from "./user";
import history from "./history";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    tab,
    business,
    history,
  },
});
